import TermsModel from '../views/models/terms';
import ResultModel from '../views/models/result';
import ForgetModel from '../views/models/forget';
import ForgetManageModel from '../views/models/forget-manage';
import ReserveModel from '../views/models/reserve';
import CompleteModel from '../views/models/complete';
import StandardsModel from '../views/models/standards';
import DriverRevise from '../views/models/dashboard/driverRevise';
import NotificationModel from '../views/models/notification';
import SendBonusModel from '../pages/dashboard/battery/activity-settlement-inquiry/send-bonus-model'
import ActivityPush from '../pages/dashboard/battery/activity-tasks-list/activityPushModal';
import Ablemodal from '../pages/dashboard/battery/activity-list/able-Modal';
import Unablemodal from '../pages/dashboard/battery/activity-list/unable-Modal';
import Connectionmodal from '../pages/dashboard/member/membership-inquiry/connection-Modal';
import OiltruckMembermodal from '../pages/dashboard/member/membership-inquiry/oiltruck-member-Modal';
import OiltruckCarmodal from '../pages/dashboard/car/query/oiltruck-car-Modal';
import ChargeModel from '../views/models/charge-model';
import ChargeActionModel from '../pages/dashboard/charge/charge-manage/modal';

const Models = {
    'terms-model': <TermsModel />, 
    'result-model': <ResultModel />,
    'forget-model': <ForgetModel />,
    'forget-manage-model': <ForgetManageModel />,
    'driver-revise': <DriverRevise />,
    'reserve-model': <ReserveModel />,
    'complete-model': <CompleteModel />,
    'standards-model': <StandardsModel />,
	'notification-model': <NotificationModel />,
    // 隨插即充
    'charge-model': <ChargeModel />,
    'charge-action-model': <ChargeActionModel />, 
    // 任務系統
    'activityPush-model': <ActivityPush />,
    'sendBonus-model': <SendBonusModel />,
    'able-model': <Ablemodal />,
    'unable-model': <Unablemodal />,
    // 
    'connection-model': <Connectionmodal />,
    'oiltruckmember-model': <OiltruckMembermodal />,
    'oiltruckcar-model': <OiltruckCarmodal />,
};
export default Models;